import { PipeTransform } from '@angular/core';

export abstract class HtmlFragmentPipe implements PipeTransform {
  protected readonly fragment: HTMLElement;
  protected constructor() {
    this.fragment = document.implementation.createHTMLDocument().body;
  }

  abstract transform(str: string): string;
}
